import React from 'react'
import Modal from 'react-modal'

const ConfirmModal = (props) => (
    <Modal
        appElement={document.getElementById('app')}
        isOpen={!!props.selectedTitle}
        onRequestClose={props.clearSelection}
        contentLabel='selectedOption'
        closeTimeoutMS={200}
        className="modal"
    >
        <h3 className="modal__title">{props.message}</h3>
        {props.selectedTitle && <p className="modal__body">{props.selectedTitle}</p>}
        <button className="button" onClick={props.confirmAction}>Okay</button>&nbsp;&nbsp;
        <button className="button" onClick={props.clearSelection}>Cancel</button>
    </Modal>
)


export default ConfirmModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js